<div class="dialog-title">Delete Sales Document</div>

<div class="value-container">
  <div class="content-wrapper full" >
    <div class="label-f">Type: </div>
    <div class="value-f">{{result?.labelType}}</div>
    <br />
    <div class="label-f">Document Name: </div>
    <div class="value-f">{{result?.labelName}}</div>
  </div>
</div>

<div class="dialog-buttons no-divider">
  <button
    mat-button
    color="primary"
    [mat-dialog-close]="false"
    (click)="close()"
  >
    Cancel
  </button>
  <button mat-button color="primary" cdkFocusInitial [mat-dialog-close]="true">
    Confirm
  </button>
</div>
